module.exports = __webpack_public_path__ + "img/1.32ed3d34.jpg";